import { FunctionComponent, memo, useEffect } from 'react';
import { useStoryCardByIdQuery } from '../../../services';
import { RightSideStoryCard } from '../RightSideStoryCard';

interface FeaturedCardProps {
  storyId: number;
  cardId: number;
  onLoaded: () => void;
}

export const FeaturedCard: FunctionComponent<FeaturedCardProps> = memo(
  ({ storyId, cardId, onLoaded }) => {
    const { data, isFetching } = useStoryCardByIdQuery({ storyId, cardId });

    useEffect(() => {
      if (!isFetching) {
        onLoaded();
      }
    }, [isFetching, onLoaded]);

    if (isFetching || !data) {
      return null;
    }

    return <RightSideStoryCard card={data} />;
  }
);
